// src/services/adminSettingsService.js
import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/admin-api/v3/admin-settings`;

const adminSettingsService = {
  // GET: Fetch all settings
  async getAllSettings(params = {}) {
    try {
      const response = await requestInstance.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching settings list:", error);
      throw error;
    }
  },

  // GET by ID
  async getSettingById(settingId) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/${settingId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching setting by id (${settingId}):`, error);
      throw error;
    }
  },

  // POST: Create a new setting
  async createSetting(settingData) {
    try {
      const response = await requestInstance.post(BASE_URL, settingData);
      return response.data;
    } catch (error) {
      console.error("Error creating setting:", error);
      throw error;
    }
  },

  // PUT: Update a setting
  async updateSetting(settingId, updatedData) {
    try {
      const response = await requestInstance.put(`${BASE_URL}/${settingId}`, updatedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating setting (${settingId}):`, error);
      throw error;
    }
  },

async deleteReason(reasonId) {
  try {
    const response = await requestInstance.delete(`${BASE_URL}/reason/${reasonId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting reason (${reasonId}):`, error);
    throw error;
  }
}

};

export default adminSettingsService;